import { render, staticRenderFns } from "./PremiosEmprendedor.vue?vue&type=template&id=652d7b7e&scoped=true&"
var script = {}
import style0 from "./PremiosEmprendedor.vue?vue&type=style&index=0&id=652d7b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d7b7e",
  null
  
)

export default component.exports